<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="mb-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.applicant}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <template>
                  <v-flex sm6 xs12>
                    <v-autocomplete :items="appNationalityList" v-model="paForm.applicant.appNationality" :label="labels.appNationality" item-text="label" item-value="value"
                      data-vv-name="appNationality" :data-vv-as="labels.appNationality" :error-messages="errors.collect('appNationality')" v-validate="'required'" prepend-icon="mdi-earth"></v-autocomplete>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-autocomplete :items="appMaritalStatusList" v-model="paForm.applicant.appMaritalStatus" :label="labels.appMaritalStatus" item-text="label" item-value="value"
                      data-vv-name="appMaritalStatus" :data-vv-as="labels.appMaritalStatus" :error-messages="errors.collect('appMaritalStatus')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appName" v-model="paForm.applicant.appName" :label="labels.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="labels.appName" v-validate="'required|name|max:50'" prepend-icon="mdi-account-card-details"/>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appNricPassport" v-uppercase="paForm.applicant.appNricPassport" v-model="paForm.applicant.appNricPassport" :label="labels.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="labels.appNricPassport" v-validate="'required|alpha_num|max:20'"/>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <cal-picker key="appDob" v-model="paForm.applicant.appDob" :label="labels.appDob" v-validate="dobValidation" :data-vv-as="labels.appDob" data-vv-name="appDob" :error-messages="errors.collect('appDob')"></cal-picker>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-radio-group key="appGender" v-model="paForm.applicant.appGender" row :label="labels.appGender" :error-messages="errors.collect('appGender')" data-vv-name="appGender" :data-vv-as="labels.appGender" v-validate="'required'">
                      <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-autocomplete :items="quoteParam.occupations" v-model="paForm.applicant.appOccupation" :label="labels.occupation" item-text="label" item-value="value" data-vv-name="occupation" :data-vv-as="labels.occupation" :error-messages="errors.collect('occupation')" v-validate="'required'">
                      <v-tooltip slot="append-outer" max-width="400" min-width="300" left>
                        <v-icon slot="activator" color="info" small>mdi-information</v-icon>
                        <span><p><b>Class 1</b> - {{tooltips.occupations1}}</p><p><b>Class 2</b> - {{tooltips.occupations2}}</p></span>
                      </v-tooltip>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-autocomplete :items="quoteParam.relationships" v-model="paForm.applicant.appRelationship" :label="labels.relationship" item-text="label" readonly
                      item-value="value" data-vv-name="relationship" :data-vv-as="labels.relationship" :error-messages="errors.collect('relationship')" v-validate="'required'"/>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appContact}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appEmail" type="email" :label="labels.appEmail" :error-messages="errors.collect('appEmail')" data-vv-name="appEmail" :data-vv-as="labels.appEmail" v-validate="'required|email'" prepend-icon="mdi-email" hint="An email acknowledgement will be sent to this address" :persistent-hint="true"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.appMobileNo" :error-messages="errors.collect('appMobileNo')" data-vv-name="appMobileNo" :data-vv-as="labels.appMobileNo" v-validate="'numeric|required'" hint="Mobile No. is required to receive SMS confirmation" :persistent-hint="true" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo1" :error-messages="errors.collect('appTelNo1')" data-vv-name="appTelNo1" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo2" :error-messages="errors.collect('appTelNo2')" data-vv-name="appTelNo2" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appAdd3" :label="labels.appAdd3" :error-messages="errors.collect('appAdd3')" data-vv-name="appAdd3" :data-vv-as="labels.appAdd3" prefix="#" v-validate="'unit_no|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appPostalCode" :label="labels.appPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('appPostalCode')" data-vv-name="appPostalCode" :data-vv-as="labels.appPostalCode" v-validate="'required|numeric'" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appAdd1" :label="labels.appAdd1" :error-messages="errors.collect('appAdd1')" data-vv-name="appAdd1" :data-vv-as="labels.appAdd1" v-validate="'required|entry|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appAdd2" :label="labels.appAdd2" :error-messages="errors.collect('appAdd2')" data-vv-name="appAdd2" :data-vv-as="labels.appAdd2" v-validate="'required|entry|max:255'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="paForm.applicant.appAdd4" :label="labels.appAdd4" :error-messages="errors.collect('appAdd4')" data-vv-name="appAdd4" :data-vv-as="labels.appAdd4" v-validate="'entry|max:255'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { gender, appNationality, maritalStatus } from '@/const/underwriting'
import toDate from 'date-fns/toDate'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      tooltips: {
        occupations1: 'Occupations which are mostly indoor\ndesk-bound such as clerical, administrative or other similar non-hazardous. Examples are accountant, lawyer, banker, doctor, teacher, nurse, secretary, etc',
        occupations2: 'Occupations where some degree of risk is involved, such as supervision of manual workers, totally administrative job in an industrial environment, professions of an outdoor nature, work involving overseas travel or work involving the occasional use of tools or machinery. Example are foreman, grocer, hairdresser, salesman, tailor, surveyor, tourist guide etc.'
      },
      labels: {
        applicant: 'Applicant',
        appNationality: 'Nationality*',
        appMaritalStatus: 'Marital Status*',
        appName: 'Name as in NRIC/Passport*',
        appNricPassport: 'NRIC/Passport*',
        appDob: 'Date of Birth*',
        appGender: 'Gender*',
        appIsInsured: 'Is Insured?',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appAdd1: 'Block/House No.*',
        appAdd2: 'Street Name*',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code*',
        appContact: 'Contacts',
        appEmail: 'Email*',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        coyName: 'Name of Company*',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business',
        occupation: 'Occupation Class',
        relationship: 'Relationship'
      },
      paForm: {
        applicant: {
          appNationality: 'SG',
          appMaritalStatus: undefined,
          appIntStat: undefined,
          appName: undefined,
          appNricPassport: undefined,
          appDob: undefined,
          appGender: undefined,
          appIsInsured: undefined,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appPostalCode: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined,
          coyName: undefined,
          coyRocUen: undefined,
          coyNature: undefined,
          appOccupation: undefined,
          appRelationship: 'SF'
        }
      },
      appPostalCodeLoading: false,
      mailPostalCodeLoading: false
    }
  },
  computed: {
    globalForm() {
      return this.$store.state.agency.quotation.paForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    quoteParam() {
      return this.$store.state.agency.quotation.paParam
    },
    appMaritalStatusList() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    appNationalityList() {
      let result = []
      Object.keys(appNationality).forEach(function (key) {
        const status = appNationality[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    selectedPlan() {
      return this.$store.getters.paQuoteSelectedPlan
    },
    dobValidation() {
      if (this.selectedPlan && (this.selectedPlan.minInsdAge !== null || typeof this.selectedPlan.minInsdAge !== 'undefined') && this.selectedPlan.maxInsdAge) {
        return { required: true, bday_range: [this.globalCommonForm.startDate, this.selectedPlan.minInsdAge, this.selectedPlan.maxInsdAge] }
      } else {
        // hardCode is cannot find age
        return { required: true, bday_range: [this.globalCommonForm.startDate, 1, 100] }
      }
    }
  },
  watch: {
    'paForm.applicant.appAdd1': function (value) {
      if (this.paForm.applicant.mailAdd) {
        this.paForm.applicant.mailAdd1 = value
      }
    },
    'paForm.applicant.appAdd2': function (value) {
      if (this.paForm.applicant.mailAdd) {
        this.paForm.applicant.mailAdd2 = value
      }
    },
    'paForm.applicant.appAdd3': function (value) {
      if (this.paForm.applicant.mailAdd) {
        this.paForm.applicant.mailAdd3 = value
      }
    },
    'paForm.applicant.appAdd4': function (value) {
      if (this.paForm.applicant.mailAdd) {
        this.paForm.applicant.mailAdd4 = value
      }
    },
    'paForm.applicant.appPostalCode': function (value) {
      if (this.paForm.applicant.mailAdd) {
        this.paForm.applicant.mailPostalCode = value
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      // Applicant
      const { applicant } = this.globalCommonForm
      this.paForm.applicant.appName = applicant.appName
      this.paForm.applicant.appGender = applicant.appGender
      this.paForm.applicant.appNricPassport = applicant.appNricPassport
      if (applicant.appDob) {
        this.paForm.applicant.appDob = toDate(applicant.appDob)
      }
      this.paForm.applicant.appIsInsured = applicant.appIsInsured
      this.paForm.applicant.appNationality = applicant.appNationality
      this.paForm.applicant.appMaritalStatus = applicant.appMaritalStatus
      this.paForm.applicant.appOccupation = applicant.appOccupation
      this.paForm.applicant.appRelationship = 'SF'
      this.paForm.applicant.appEmail = applicant.appEmail
      this.paForm.applicant.appMobileNo = applicant.appMobileNo
      this.paForm.applicant.appTelNo1 = applicant.appTelNo1
      this.paForm.applicant.appTelNo2 = applicant.appTelNo2
      this.paForm.applicant.appPostalCode = applicant.appPostalCode
      this.paForm.applicant.appAdd1 = applicant.appAdd1
      this.paForm.applicant.appAdd2 = applicant.appAdd2
      this.paForm.applicant.appAdd3 = applicant.appAdd3
      this.paForm.applicant.appAdd4 = applicant.appAdd4
      this.paForm.applicant.mailAdd = applicant.mailAdd
      this.paForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.paForm.applicant.mailAdd1 = applicant.mailAdd1
      this.paForm.applicant.mailAdd2 = applicant.mailAdd2
      this.paForm.applicant.mailAdd3 = applicant.mailAdd3
      this.paForm.applicant.mailAdd4 = applicant.mailAdd4

      if (this.paForm.applicant.appIsInsured === null || this.paForm.applicant.appIsInsured === undefined) {
        this.paForm.applicant.appIsInsured = true
      }
    },
    async doAppAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.paForm.applicant.appPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.paForm.applicant.appAdd1 = data.add1
            this.paForm.applicant.appAdd2 = data.add2
            this.paForm.applicant.appAdd4 = data.add4
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'paQuotePlans' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.paForm.applicant.appMobileNo && this.paForm.applicant.appMobileNo !== '') ||
            (this.paForm.applicant.appTelNo1 && this.paForm.applicant.appTelNo1 !== '') ||
            (this.paForm.applicant.appTelNo2 && this.paForm.applicant.appTelNo2 !== '')) {
            this.$store.dispatch('paQuoteApplicant', this.paForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
            this.$router.push({ name: 'paQuoteInsured' })
          } else {
            this.promptFieldCheck()
            this.errorMessage('At least one of the contact number is required')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.dispatch('paQuoteApplicant', this.paForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
